import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ChapterArt } from "@/components/ChapterArt";
import { capabilities, serviceAreas } from "@/content/siteContent";

export default function Capabilities() {
  return (
    <div data-testid="capabilities-page">
      <header className="bg-sand">
        <div className="relative mx-auto max-w-6xl px-6 pb-20 pt-20 sm:pt-28">
          <div className="hidden sm:block">
            <ChapterArt testId="page-art-capabilities" />
          </div>
          <Reveal>
            <p className="eyebrow">Capabilities</p>
            <h1 className="mt-6 max-w-4xl text-4xl font-black leading-tight tracking-tighter sm:text-5xl">
              Combining business strategy, analytical thinking, and technology to turn complexity
              into clarity.
            </h1>
          </Reveal>
        </div>
      </header>

      <section className="bg-white">
        <div className="mx-auto max-w-6xl px-6 py-20 sm:py-28">
          <Reveal>
            <SectionHeading index="01" label="Capabilities" />
          </Reveal>
          <div className="mt-14 grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-testid="capabilities-grid">
            {capabilities.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.06}>
                <div className="border-t-2 border-ink pt-6" data-testid={`capability-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
                  <h2 className="text-base font-bold tracking-tight sm:text-lg">{c.title}</h2>
                  <p className="mt-4 text-sm leading-relaxed text-muted sm:text-base">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-charcoal" data-testid="service-areas-section">
        <div className="mx-auto max-w-6xl px-6 py-20 sm:py-28">
          <Reveal>
            <SectionHeading dark index="02" label="Service areas" />
          </Reveal>
          <Reveal delay={0.1}>
            <ul className="mt-12 grid gap-x-12 gap-y-4 sm:grid-cols-2" data-testid="service-areas-list">
              {serviceAreas.map((s) => (
                <li key={s} className="border-b border-sand/15 pb-4 text-base font-medium tracking-tight text-sand">
                  {s}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
